import React, { useEffect, useState } from "react";
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogContent,
	Fab,
	IconButton,
	Tooltip,
	Typography,
} from "@mui/material";
import AlertMsg from "../component/AlertMsg";
import CloseIcon from "@mui/icons-material/Close";
import Axios from "axios";
import constants from "../Constants";
import AddIcon from "@mui/icons-material/Add";
import AddAndEditClass from "./AddAndEditClass";
import ConfirmModal from "../component/ConfirmModal";
import AddStudentToClass from "./AddStudentToClass";
import TableComponent from "../component/TableComponent";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import moment from "moment-jalaali";
import FormatHelper from "../helper/FormatHelper";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStudents } from "../store/actions";

function ClassManagement({ classManageOpen, setClassManageOpen }) {
	const students = useSelector(state => state.students);
	const info = useSelector(state => state.info);
	const dispatch = useDispatch();
	const [msg, setMsg] = useState(null);
	const [loading, setLoading] = useState(false);
	const [isFetch, setIsFetch] = useState(false);
	const [classList, setClassList] = useState(false);
	const [flag, setFlag] = useState({
		title: "مدیریت کلاس ها",
		status: 0,
		data: null,
	});
	const [confirmLoading, setConfirmLoading] = useState(false);
	const [confirmModal, setConfirmModal] = useState({
		confirmOpen: false,
		id: null,
		studentId: null,
		type: null,
	});
	const [modalOpen, setModalOpen] = useState({
		open: false,
		type: "",
		data: null,
	});
	const [studentModal, setStudentModal] = useState(false);
	const [classStudents, setClassStudents] = useState([]);

	const fetchClassList = async () => {
		try {
			setLoading(true);
			setMsg(null);
			const response = await Axios.get(
				constants.baseUrl + "/class/list/" + info?.id,
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			console.log(response);

			if (response.data.status === 202) {
				setClassList(response.data.result.classes);
				setIsFetch(true);
			} else {
				setMsg({
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
				setIsFetch(false);
			}
		} catch (err) {
			setMsg({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
			setIsFetch(false);
		} finally {
			setLoading(false);
		}
	};

	const deleteApi = async () => {
		try {
			setConfirmLoading(true);
			setMsg(null);
			const url =
				confirmModal.type === "class"
					? `${constants.baseUrl}/class/${confirmModal.id}`
					: `${constants.baseUrl}/class/remove/member/${confirmModal.id}`;

			const response = await Axios.delete(url, {
				headers: {
					authorization: "Bearer " + localStorage.getItem("schoolToken"),
				},
			});
			if (response.data.status === 202) {
				setMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "حذف شد",
				});
				fetchClassList();
				setClassStudents(prev => prev.filter(p => p.id !== confirmModal.studentId));
				if (confirmModal.type === "student") {
					const copyStudents = [...students];
					const removeStudent = copyStudents.find(
						s => s.id === confirmModal.studentId
					);
					removeStudent.class = null;
					dispatch(setUpdateStudents([removeStudent]));
				}
				if (confirmModal.type === "class") {
					const copyStudents = [...students];
					copyStudents.forEach(
						s => s.class?.classId === confirmModal.id && (s.class = null)
					);
					dispatch(setUpdateStudents(copyStudents));
				}
			} else {
				setMsg({
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setMsg({
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		} finally {
			setConfirmLoading(false);
			setConfirmModal({
				confirmOpen: false,
				id: null,
				studentId: null,
				type: null,
			});
		}
	};

	useEffect(() => {
		info.id && fetchClassList();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [info]);

	return (
		<Dialog open={classManageOpen} fullScreen>
			<Box
				px={2}
				pt={1}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"space-between"}>
				<Box className="d-flex" gap={2}>
					{flag.status === 1 && (
						<IconButton
							size="small"
							sx={{
								backgroundColor: "#ccc",
							}}
							onClick={() => {
								setFlag({ status: 0, title: "مدیریت کلاس ها" });
							}}>
							<ArrowForwardIosIcon />
						</IconButton>
					)}
					<Typography fontSize={16} fontWeight={700}>
						{flag.title}
					</Typography>
				</Box>
				<IconButton
					onClick={() => {
						setClassManageOpen(false);
						setTimeout(() => {
							setFlag({ status: 0, title: "مدیریت کلاس ها" });
						}, 500);
					}}>
					<CloseIcon />
				</IconButton>
			</Box>
			<DialogContent>
				{msg ? (
					msg.type ? (
						<AlertMsg message={msg} type={"success"} />
					) : (
						<AlertMsg message={msg} type={"error"} />
					)
				) : null}

				{loading ? (
					<Box className="d-flex-column" mt={5}>
						درحال دریافت اطلاعات
						<CircularProgress color="secondary" sx={{ my: 2 }} />
					</Box>
				) : !isFetch ? (
					<Button
						onClick={fetchClassList}
						variant="contained"
						color="secondary"
						sx={{ color: "white" }}>
						تلاش مجدد
					</Button>
				) : (
					<>
						{flag.status === 0 ? (
							<TableComponent
								type="class"
								data={classList}
								header={[
									{
										key: "classCreatetime",
										label: "تاریخ ایجاد",
										render: value =>
											FormatHelper.toPersianString(
												`${moment(value, "X").format("jYYYY/jMM/jDD")}`
											),
									},
									{
										key: "className",
										label: "نام کلاس",
										render: value => FormatHelper.toPersianString(`${value}`),
									},
									{
										key: "advisorFullName",
										label: "نام مشاور",
										render: (_, item) =>
											`${item.advisorFirstName} ${item.advisorLastName}`,
									},
									{
										key: "advisorMobile",
										label: "شماره مشاور",
										render: value => FormatHelper.toPersianString(`${value}`),
									},
									{
										key: "members",
										label: "اعضا",
										render: value => FormatHelper.toPersianString(`${value}`),
									},
									{ key: "classDescription", label: "توضیحات" },
								]}
								allStudents={students}
								setFlag={setFlag}
								setClassStudents={setClassStudents}
								setModalOpen={setModalOpen}
								setConfirmModal={setConfirmModal}
							/>
						) : (
							<TableComponent
								type="student"
								data={classStudents}
								header={[
									{
										key: "studentFullName",
										label: "نام دانش آموز",
										render: (_, item) => `${item.firstName} ${item.lastName}`,
									},
									{ key: "city", label: "شهر" },
									{
										key: "mobile",
										label: "شماره دانش آموز",
										render: value => FormatHelper.toPersianString(`${value}`),
									},
									{
										key: "grade",
										label: "پایه",
										render: (_, item) => item?.grade?.name,
									},
									{
										key: "balance",
										label: "موجودی",
										render: value => FormatHelper.toPersianString(`${value}`),
									},
								]}
								allStudents={students}
								setFlag={setFlag}
								setClassStudents={setClassStudents}
								setModalOpen={setModalOpen}
								setConfirmModal={setConfirmModal}
							/>
						)}
					</>
				)}
			</DialogContent>

			<Tooltip title={flag.status === 0 ? "ایجاد کلاس" : "افزودن دانش آموز"} arrow>
				<Fab
					color="primary"
					sx={{ position: "absolute", left: 20, bottom: 20 }}
					onClick={() => {
						flag.status === 0
							? setModalOpen({ open: true, type: "add" })
							: setStudentModal(true);
					}}>
					{flag.status === 0 ? <AddIcon /> : <PersonAddIcon />}
				</Fab>
			</Tooltip>

			<AddAndEditClass
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
				fetchClassList={fetchClassList}
			/>
			<AddStudentToClass
				allStudents={students}
				studentModal={studentModal}
				setStudentModal={setStudentModal}
				classData={flag.data || {}}
				setClassStudents={setClassStudents}
				fetchClassList={fetchClassList}
				setMsg={setMsg}
			/>
			<ConfirmModal
				title={
					confirmModal.type === "class"
						? "آیا از حذف این کلاس اطمینان دارید ؟"
						: "آیا از حذف این دانش آموز اطمینان دارید ؟"
				}
				open={confirmModal}
				setOpen={setConfirmModal}
				loading={confirmLoading}
				runFunc={deleteApi}
			/>
		</Dialog>
	);
}

export default ClassManagement;
